<script>
import WideIconTile from '@/components/WideIconTile'
import EnvironmentUtils from '@/utils/environmentUtils'
import StoreNotificationsServices from '@/services/storeNotifications'
import StoresServices from '@/services/stores'

export default
{
    name: 'store-notification-element',

    props:
    {
        notificationId: {type: Number, required: true},
        id: {type: String}
    },

    mixins: [WideIconTile],

    created ()
    {
        const cityId = EnvironmentUtils.cityId
        StoresServices.fetchStores(cityId).then(async stores  =>
        {
            await this.$store.commit('stores/updateStoreList', stores)

            StoreNotificationsServices.fetchStoreNotifications(cityId).then(notifications =>
            {
                this.$store.commit('storeNotifications/updateNotificationList', notifications)
            })
        })
    },

    render () 
    {
        return (
            <wide-icon-tile id={this.id} class='store-notification-element' title={this.notification.title} pictures={this.notification.pictures}
                icon={this.store.pictures[0]} on-click={this.$listeners.click || (() => {})}>
                {this.notification.content}
            </wide-icon-tile>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
        notification ()
        {
            return this.$store.state.storeNotifications.notificationList.find(n => n.id == this.notificationId)
        },

        store ()
        {
            return this.$store.getters.stores.getStoreById(this.notification.storeId)
        }
    },

    methods:
    {
    },

    components:
    {
        WideIconTile
    }
}
</script>

<style lang='less'>
.store-notification-element
{
    &.wide-icon-tile
    {
        padding: 14px 13px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/StoreNotificationElement.vue